module.exports = __webpack_public_path__ + "img/people-33-min.97bbc521.png";